<template>
  <modal  class="dialer_animation right_side_popup GenerateTimeOffReportsModal HrmForModalScroll" :clickToClose="true"  :scrollable="true" name="AddNewEmployeeDataPosition">
    <div class="modalHeading-container">
      <div class="modalHeading">Add position</div>
      <button type="button" class="dialer-button dialer-button-delete" @click="$modal.hide('AddNewEmployeeDataPosition')">Close</button>
    </div>
    <div class="modalInner-container">
      <div class="innerShadowInput-container ">
        <label>Position *</label>
        <input class=""/>
      </div>
      <div class="innerShadowInput-container ">
        <label>Description</label>
        <textarea class=""/>
      </div>
      <div class="innerShadowInput-container ">
        <label>Position code</label>
        <input class=""/>
      </div>
      <button class="dialer-button dialer-button-primary mt-32px mr-0"> Add </button>
    </div>
  </modal>
</template>

<script>
export default {
  name: 'AddNewEmployeeDataPosition',
}
</script>

<style>

</style>